import { configureStore, type Middleware, type UnknownAction } from '@reduxjs/toolkit';
import authReducer, {
  syncImpersonationToStorage,
  setImpersonatedUser,
  clearImpersonation,
  setAuthState
} from './user/userSlice';
import campaignsReducer from './campaign/slice';
import sessionsReducer from './session/slice';
import transcriptsReducer from './transcript/slice';

const IMPERSONATION_ACTIONS = new Set<string>([
  setImpersonatedUser.type,
  clearImpersonation.type,
  setAuthState.type
]);

const impersonationStorageMiddleware: Middleware = (store) => (next) => (action: unknown) => {
  const result = next(action);
  const typedAction = action as UnknownAction;
  if (typedAction.type && IMPERSONATION_ACTIONS.has(typedAction.type as string)) {
    const { impersonatedUserId, impersonatedUser } = store.getState().auth;
    syncImpersonationToStorage(impersonatedUserId, impersonatedUser);
  }
  return result;
};

export const store = configureStore({
  reducer: {
    auth: authReducer,
    campaigns: campaignsReducer,
    sessions: sessionsReducer,
    transcripts: transcriptsReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(impersonationStorageMiddleware)
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
